import { NEW_CHROME_LINK, NEW_EDGE_LINK, NEW_FIREFOX_LINK, NEW_SAFARI_LINK } from '../../../utils';
import { BannerLink } from '../styled';
import type { ReactNode } from 'react';

export type LinkValueRenderer = (chunks: ReactNode[]) => ReactNode;

const createLinkRenderer = (to: string, key: string): LinkValueRenderer => {
    const BrowserLinkRenderer = (chunks: ReactNode[]) => (
        <BannerLink
            variant="body2"
            key={key}
            color="inherit"
            colorHover="inherit"
            target="_blank"
            to={to}
        >
            {chunks}
        </BannerLink>
    );

    return BrowserLinkRenderer;
};

export const chromeLinkRenderer = createLinkRenderer(NEW_CHROME_LINK, 'link1');
export const edgeLinkRenderer = createLinkRenderer(NEW_EDGE_LINK, 'link2');
export const safariLinkRenderer = createLinkRenderer(NEW_SAFARI_LINK, 'link1');
export const firefoxLinkRenderer = createLinkRenderer(NEW_FIREFOX_LINK, 'link1');

export const chromiumLinkValues = {
    link1: chromeLinkRenderer,
    link2: edgeLinkRenderer,
};
